module.exports = __webpack_public_path__ + "static/media/white-delete-measure-icon.9155d042.svg";